import { Link, Typography } from '@montugroup/design-system';
import { Box, styled } from '@mui/material';
import SuccessConfetti from '../../assets/images/onboard/success-confetti.gif';

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  padding: theme.spacing(4),
  gap: theme.spacing(4),
  maxWidth: 850,
}));

const TextStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

function OnboardingSuccess() {
  return (
    <Container>
      <Box
        component="img"
        src={SuccessConfetti}
        data-testid="confetti-image"
        alt='"Confetti celebrating successful onboarding"'
        style={{
          width: '219',
          height: '291',
        }}
      ></Box>

      <Box>
        <Typography variant="subtitle1" gutterBottom>
          You’re now part of our pharmacy network
        </Typography>
        <TextStyled>
          <Typography>Welcome, we’re so excited to have you on board!</Typography>

          <Typography>
            Your onboarding details are now on their way to our fulfilment team for review and approval.
          </Typography>

          <Typography>
            We’ll reach out within{' '}
            <Typography component="span" fontWeight="bold">
              2 business days
            </Typography>{' '}
            to guide you through the next step, getting you ready for medication dispensing.
          </Typography>

          <Typography fontStyle="italic">
            Keep an eye on your inbox – and maybe give your junk folder a quick look too (emails have a talent for
            hiding when they’re shy).
          </Typography>

          <Typography>
            Thanks for joining us, we can’t wait to work together. If you have any questions in the meantime, feel free
            to reach out at{' '}
            <Link href="mailto:pharmacy-escalations@montu.com.au">
              <Typography component="span" fontWeight="bold">
                pharmacy-escalations@montu.com.au
              </Typography>
            </Link>
            .
          </Typography>
        </TextStyled>
      </Box>
    </Container>
  );
}

export default OnboardingSuccess;
